<div class="user-profile" nzJustify="space-around" nzAlign="middle">

  <button
    class="logout-btn work-time-profile-btn"
    [class.working]="isWorking"
    [class.not-working]="!isWorking"
    nz-button
    nz-dropdown
    [nzDropdownMenu]="menu"
    nzTrigger="click">
    <span class="work-time-profile-content">
      <span class="work-time-profile-dot"></span>
      <span class="work-time-profile-time">{{totalWorkTime || '0 min'}}</span>
      <nz-avatar
        nzIcon="user"
        nzSrc="{{googleUser.photoUrl}}"
        [nzSize]="'small'"
        class="profile-avatar">
      </nz-avatar>
    </span>
  </button>

     
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu nzSelectable >
          <!-- <li  routerLink="/my-profile" nz-menu-item><span nz-icon nzType="user" nzTheme="outline"></span>
            <span style="margin-left: 10px;">My Profile</span></li> -->
            <li (click)="signOut()" nz-menu-item ><i nz-icon nzType="logout" nzTheme="outline"></i>
              <span style="margin-left: 10px;">Logout</span>
            </li>
        </ul>
      </nz-dropdown-menu>
     

  </div>
